import React, { useEffect, useState } from 'react';
import UpdateScorerForm from 'app/components/match/liveResult/updateScorer/UpdateScorerForm';
import { catchDataError } from 'app/helpers/apiHelpers';
import { api, authorizedAPI } from 'app/services/api';
import { useSoftTickerContext } from 'app/hooks/useSoftTickerContext';
import isAxiosError from 'app/helpers/isAxiosError';
const getPlayers = matchSlug => {
  return api.get("/matches/".concat(matchSlug, "/players"));
};
const fieldMapper = {
  assistantId: 'assistant',
  awayGoals: 'awayGoals',
  homeGoals: 'homeGoals',
  minute: 'minute',
  scorerId: 'scorer',
  teamId: 'team',
  type: 'category'
};
const storeGoalEvent = (matchSlug, data, matchEventId) => {
  return matchEventId ? authorizedAPI.put("/matches/".concat(matchSlug, "/goals/").concat(matchEventId), data) : authorizedAPI.post("/matches/".concat(matchSlug, "/goals"), data);
};
const UpdateScorer = _ref => {
  var _softTickerData$score;
  let {
    match,
    onClose,
    onUpdateScorer,
    onDelete
  } = _ref;
  const [players, setPlayers] = useState(null);
  const [loadingPlayers, setLoadingPlayers] = useState(false);
  const [playersError, setPlayersError] = useState(null);
  const [submissionLoading, setSubmissionLoading] = useState(false);
  const [requestError, setRequestError] = useState(null);
  const {
    softTickerData
  } = useSoftTickerContext();
  useEffect(() => {
    if (match.slug) {
      setLoadingPlayers(true);
      getPlayers(match.slug).then(response => {
        setPlayers(response.data);
        setLoadingPlayers(false);
      }).catch(error => {
        setPlayersError(catchDataError(error));
        setLoadingPlayers(false);
      });
    }
  }, [match]);
  const handleUpdateScorer = (matchEvent, isUpdate) => {
    onUpdateScorer(matchEvent, isUpdate);
  };
  const onSubmit = (data, setFieldError) => {
    setSubmissionLoading(true);
    storeGoalEvent(match.slug, data, softTickerData.matchEventId).then(response => {
      setSubmissionLoading(false);
      handleUpdateScorer(response.data, !!softTickerData.matchEventId);
    }).catch(error => {
      setSubmissionLoading(false);
      if (isAxiosError(error)) {
        var _error$response;
        const errorData = (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error;
        if ((errorData === null || errorData === void 0 ? void 0 : errorData.code) === 422) {
          // Validation-Error
          const fields = errorData.fields;
          if (fields && Object.keys(fields).length) {
            Object.keys(fields).forEach(field => {
              var _fields$field$, _fields$field;
              const input = fieldMapper[field];
              setFieldError(input, {
                type: 'custom',
                message: (_fields$field$ = (_fields$field = fields[field]) === null || _fields$field === void 0 ? void 0 : _fields$field[0]) !== null && _fields$field$ !== void 0 ? _fields$field$ : errorData.translated_message
              });
            });
            return;
          }
        }
        if (errorData !== null && errorData !== void 0 && errorData.translated_message) {
          return setRequestError(errorData.translated_message);
        }
      }
      return setRequestError('Es ist ein unbekannter Fehler aufgetreten, versuchen sie es später erneut.');
    });
  };
  return /*#__PURE__*/React.createElement(UpdateScorerForm, {
    match: match,
    onClose: onClose,
    onDelete: onDelete,
    initData: (_softTickerData$score = softTickerData.scorerFormData) !== null && _softTickerData$score !== void 0 ? _softTickerData$score : softTickerData.resultData,
    matchEventId: softTickerData.matchEventId,
    players: players,
    onSubmit: onSubmit,
    submissionLoading: submissionLoading,
    submissionError: requestError,
    "data-sentry-element": "UpdateScorerForm",
    "data-sentry-component": "UpdateScorer",
    "data-sentry-source-file": "UpdateScorer.tsx"
  });
};
export default UpdateScorer;